import { recipientMiscDocConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveRecipientMiscDoc = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressMiscDoc.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':docId', form.id) :
            url.recipientProgressMiscDocs.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_REQUEST }),
        success: (data) => ({ type: recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_SUCCESS, data }),
        failure: (error) => ({ type: recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved document.' }
        }
    }
});

export const deleteRecipientMiscDoc = ({ recipientId, progressId, docId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressMiscDoc.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':docId', docId),
        method: 'DELETE',
        request: () => ({ type: recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_REQUEST }),
        success: (data) => ({ type: recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_SUCCESS, data }),
        failure: (error) => ({ type: recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_FAILURE, error }),
        formatData: () => (docId),
        progress: {
            request: { message: () => 'Deleting document' },
            success: { message: () => 'Deleted document.' }
        }
    }
});

export const loadRecipientMiscDocs = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressMiscDocs.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_REQUEST }),
        success: (data) => ({ type: recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_SUCCESS, data }),
        failure: (error) => ({ type: recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/recipientMiscDoc.actions.js